export enum COLORS {
    PRIMARY = '#3bb34a',
    SECONDARY = '#d7e9b7',
    BACKGROUND = '#fff'
}
